import React, { useEffect, useState, useCallback, useContext } from "react";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import { useAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { muchAndLearnMngtThunk } from "../../../../store/actions/trainingmanagement/training.thunk";
import AddTheme from "./addTheme";
import moment from "moment";
import useModal from "../../../../utils/useModal";
import Modal from "react-modal";
import { ApiService } from "../../../../services/ApiService";
import { ConfirmTemplate } from "../../../../components/confirm";
import EditTheme from "./edit_theme";
import { employeeMngtThunk } from "../../../../store/actions/employeemanagement/employee.thunk";
import { PageBody } from "../../../../components/loader";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";
import { AuthContext } from "../../../../Context/AuthContext";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

export const TrainingThemeIndex = () => {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const [themeWeek, setThemeWeek] = useState({});
  const [theme, setTheme] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const { themeOfTheWeek } = useSelector((state) => state.trainingMngt);
  const { employees } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();
  const { modalIsOpen, openModal, closeModal } = useModal();

  const editOpen = () => {
    setEditModalOpen(true);
  };

  const closeEdit = () => {
    setEditModalOpen(false);
  };

  const getAllThemOfTheWeek = useCallback(async () => {
    updateLoader(true, "Getting all themes");
    await dispatch(muchAndLearnMngtThunk.getAllThemeOfTheWeek());
    await dispatch(employeeMngtThunk.getEmployeesDetails());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    setThemeWeek(themeOfTheWeek[0]);
  }, [themeOfTheWeek]);

  useEffect(() => {
    getAllThemOfTheWeek();
  }, []);

  const deleteRequest = (id) => {
    const request = async () => {
      // const id = {
      //   id: ids,
      // };
      const res = await ApiService.delete(
        `trainings/delete-theme-of-the-week/${id}`
      );
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getAllThemOfTheWeek();
      }
    };
    ConfirmTemplate(
      {
        title: "Delete Theme Of The Week",
        message: "Are You Sure You Want To Delete This Theme Of The Week",
      },
      request
    );
  };
  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <TrainingNavbar openThemeModal={openModal} />
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="add cases modal"
        >
          <AddTheme
            closeModal={closeModal}
            alert={alert}
            users={employees}
            getThemes={getAllThemOfTheWeek}
          />
        </Modal>
        <Modal
          isOpen={editModalOpen}
          onRequestClose={closeEdit}
          style={customStyles}
          contentLabel="add cases modal"
        >
          <EditTheme
            closeModal={closeEdit}
            alert={alert}
            users={employees}
            getThemes={getAllThemOfTheWeek}
            theme={theme}
          />
        </Modal>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="table-wrapper table-responsive">
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-xs-12"
                      id="munch_learn_content_wrapper"
                    >
                      <div className="mb-3 clearfix">
                        <div
                          class="btn-group float-left"
                          role="group"
                          aria-label="Basic example"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary btn-group-sm"
                            onClick={() => window.print()}
                          >
                            Print
                          </button>
                          <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="btn btn-secondary btn-group-sm"
                            table="theme"
                            filename="THEME OF THE WEEK"
                            sheet="tablexls"
                            buttonText="Export to excel"
                          />
                        </div>
                      </div>
                      <div class="">
                        <table
                          id="theme"
                          class="table table-striped table-bordered learn-table"
                        >
                          <thead>
                            <tr>
                              <th class="th-sm">
                                <b> NO </b>
                              </th>
                              <th class="th-sm" style={{ width: "250px" }}>
                                <b> NAME </b>
                              </th>
                              <th class="th-sm" style={{ width: "200px" }}>
                                <b> DUE DATE </b>
                              </th>
                              <th class="th-sm" style={{ width: "270px" }}>
                                <b> THEME </b>
                              </th>
                              <th class="th-sm" style={{ width: "200px" }}>
                                <b> EMAIL </b>
                              </th>
                              <th class="th-sm" style={{ width: "200px" }}>
                                <b> DATE CREATED </b>
                              </th>
                              <th class="th-sm" style={{ width: "200px" }}>
                                <b> STATUS </b>
                              </th>
                              {(user.data.user.roles &&
                                user.data.user.roles.name ===
                                  "training manager") ||
                              user.data.user.roles.name === "admin" ? (
                                <th class="th-sm notexport">
                                  <b>ACTION</b>
                                </th>
                              ) : null}
                            </tr>
                          </thead>
                          <tbody>
                            {themeOfTheWeek.map((theme, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{theme.name}</td>
                                <td> {moment(theme.due_date).format("ll")} </td>
                                <td>{theme.theme}</td>
                                <td> {theme.email}</td>
                                <td>
                                  {" "}
                                  {moment(theme.created_at).format("ll")}{" "}
                                </td>
                                <td>
                                  {themeWeek && themeWeek.id === theme.id ? (
                                    <div className="text-success">Active</div>
                                  ) : (
                                    <div className="text-danger">Inactive</div>
                                  )}
                                </td>
                                <td>
                                  {(user.data.user.roles &&
                                    user.data.user.roles.name ===
                                      "training manager") ||
                                  user.data.user.roles.name === "admin" ||
                                  user.data.user.roles.name ===
                                    "line manager" ||
                                  user.data.user.roles.name ===
                                    "human resource" ? (
                                    <div class="dropdown pull-right">
                                      <a
                                        href="#"
                                        class="dropdown-toggle card-drop arrow-none"
                                        data-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <h3 class="m-0 text-muted">
                                          <i class="fa fa-ellipsis-v"></i>
                                        </h3>
                                      </a>
                                      <div
                                        class="dropdown-menu dropdown-menu-right"
                                        aria-labelledby="btnGroupDrop1"
                                      >
                                        <Link
                                          className="dropdown-item"
                                          id="edit_theme"
                                          onClick={() => {
                                            const value = {
                                              id: theme.id,
                                              name: theme.name,
                                              due_date: theme.due_date,
                                              email: theme.email,
                                              theme: theme.theme,
                                            };
                                            setTheme(value);
                                            editOpen();
                                          }}
                                        >
                                          Edit
                                        </Link>
                                        <Link
                                          class="dropdown-item"
                                          onClick={() => {
                                            deleteRequest(theme.id);
                                          }}
                                        >
                                          Delete
                                        </Link>
                                      </div>
                                    </div>
                                  ) : null}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/themeoftheweek/index.js